module.exports = __webpack_public_path__ + "img/schedule.525c4a85.png";